import { render, staticRenderFns } from "./departure_board.vue?vue&type=template&id=21bbd503&scoped=true&"
import script from "./departure_board.vue?vue&type=script&lang=js&"
export * from "./departure_board.vue?vue&type=script&lang=js&"
import style0 from "./departure_board.vue?vue&type=style&index=0&id=21bbd503&scoped=true&lang=css&"
import style1 from "./departure_board.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbd503",
  null
  
)

export default component.exports